jQuery(document).ready(function() {
    $('.contact-page--details-mobile-toggle').click(function() {
        $(this).parent().toggleClass('contact-info-dropdown active');
    });
});